import { render, staticRenderFns } from "./ItemClaimOrderContent.vue?vue&type=template&id=22351ea8&scoped=true&"
import script from "./ItemClaimOrderContent.vue?vue&type=script&lang=js&"
export * from "./ItemClaimOrderContent.vue?vue&type=script&lang=js&"
import style0 from "./ItemClaimOrderContent.vue?vue&type=style&index=0&id=22351ea8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22351ea8",
  null
  
)

export default component.exports